import React, { useState, useEffect } from "react";
import Slider from "react-slick";
const images = require.context("../assets/images", false);


const NextArrow = ({ onClick }) => (
  <button className="custom-next" onClick={onClick}>
    <img src={images("./Forward.svg")} alt="next" />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button className="custom-prev" onClick={onClick}>
    <img src={images("./backward.svg")} alt="prev" />
  </button>
);

function Partners() {
const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const updateSlides = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setSlidesToShow(2);
      } else if (width < 992) {
        setSlidesToShow(3);
      } else {
        setSlidesToShow(5);
      }
    };

    updateSlides(); // run immediately

    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);

const settings = {
  dots: true,
  infinite: true,
  slidesToShow: slidesToShow,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  speed: 500,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />
};

  const partners = [
    images("./part1.png"),
    images("./part2.png"),
    images("./part3.png"),
    images("./maidens-hotel-logo-transparent.png"),
    images("./part5.png"),
    images("./part6.png"),
    images("./part7.png"),
    images("./part8.png"),
    images("./part9.png"),
    images("./part10.png"),
    images("./part11.png"),
    images("./tajlogo-removebg-preview.png"),
  ];
	return (
<div className="partners mt-80 paddingY-50">
  <div className="container">
    <div className="heading center">
      <h2>Hotel Partners</h2>
      <p>Luxury at the best</p>
    </div>
    <div className="row">
    <div className="col-12 partner-slider-main">
      <Slider {...settings}>
        {partners.map((image, index) => (
          <div key={index} className="partners-card center">
            <img 
              src={`${image}`} 
              alt={`partner-${index}`} 
              style={{ width: "100%" }}
            />
          </div>
        ))}
      </Slider>
    </div>
    </div>
  </div>
</div>

	);
}

export default Partners;
